<template>
  <div class="related-est">
    <div
      v-if="filteredItems.length"
      class="custom-dropdown additional-menu-search-filter related-est__list"
    >
      <a
        v-for="itm in filteredItems"
        :key="itm.key"
        class="tabs-nav-right-search-dropdown-item d-flex"
        :class="{'active': true}"
        href="#"
        @click.prevent.stop="onSelect(itm)"
        @keydown.enter.prevent="onSelect(itm)"
      >
        <div class="related-est__thumb">
          <img v-if="vendorId && thumbHash && itm && itm.card_id && itm.pinImageId"
               :src="appConfig.baseAPIURL+'/files/thumbs/' + vendorId + '/' + thumbHash + '/' + itm.card_id + '/' + itm.pinImageId + '/' + itm.pinImageId + '_w60.jpg'"
               :style="{ width: '60px' }"
          />
          <img v-else
               :style="{ width: '60px', height: '60px' , opacity: 0 }"
               src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
               alt=""
          />
        </div>
        <div style="width: 100%">
          <div
            class="tabs-nav-right-search-dropdown-item-header"
            :class="{'active': true}"
          >
            <span class="tabs-nav-right-search-dropdown-item-header-weight">
              {{ itm.estimateNumber }}
              <span v-if="itm.regoNumber"> - {{ itm.regoNumber }}</span>
              -
            </span>
            <span class="related-est__customer">{{ itm.customerName }}</span>
          </div>
          <div class="tabs-nav-right-search-dropdown-item-footer">
            <span
              v-if="itm.make || itm.model"
              class="related-est__vehicle"
            >
              {{ itm.make }} {{ itm.model }}
              <span v-if="itm.buildDate"> - {{ itm.buildDate }}</span>
            </span>
          </div>
          <div class="tabs-nav-right-search-dropdown-item-footer related-est__created-date">
            <div>
              <span
                  v-if="itm.insurerName"
                  class="related-est__insurer"
              >
              {{ itm.insurerName }}
            </span>
            </div>
            <span
              v-if="itm.createdDate"
              class="tabs-nav-right-search-dropdown-item-header  active"
            >
              <span class="tabs-nav-right-search-dropdown-item-header-weight">
                {{ formatCreatedDate(itm.createdDate) }}
              </span>
            </span>
          </div>
          <!-- <div class="tabs-nav-right-search-dropdown-item-footer">
            <span
              v-if="itm.insurerName"
              class="related-est__insurer"
            >
              {{ itm.insurerName }}
            </span>
          </div> -->
        </div>
      </a>
    </div>
    <div v-else class="related-est__empty">
      <div>No related estimates found.</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { appConfig } from '@/config'
import * as dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export default {
  name: 'related-est',
  emits: ['select', 'count'],
  props: {
    filterText: {
      type: String,
      default: '',
    },
    excludeId: {
      type: [Number, String],
      default: null,
    },
  },
  watch: {
    filteredItems: {
      immediate: true,
      handler (items) {
        this.$emit('count', items.length)
      },
    },
  },
  computed: {
    ...mapGetters({
      getterAllEstimates: 'estimate/getAllEstimates',
      vendorId: 'vendorId',
      thumbHash: 'thumbHash',
    }),
    appConfig () {
      return appConfig
    },
    filteredItems() {
      if (!this.filterText) return [];

      const query = _.trim(_.toLower(this.filterText));
      const allEstimates = this.getterAllEstimates;
      const filtered = [];

      for (let i = 0; i < allEstimates.length; i++) {
        const itm = allEstimates[i];
        const val = itm.value || itm.estimate_id || itm.id || null;
        if (this.excludeId !== null && val !== null && String(val) === String(this.excludeId)) {
          continue;
        }

        const rego = _.trim(_.toLower(itm.rego_number || itm.regoNumber || itm.rego || ''));
        if (rego === query) {
          const normalized = this.normalizeItem(itm, i);
          normalized._timestamp = this.toTimestamp(normalized.createdDate);
          filtered.push(normalized);
        }
      }
      return _.orderBy(
          filtered,
          ['_timestamp', 'estimateNumber'],
          ['desc', 'desc']
      );
    },
  },
  methods: {
    toTimestamp (value) {
      const d = this.parseDate(value)
      return d ? d.valueOf() : 0
    },
    parseDate (value) {
      if (!value) {
        return null
      }
      const d = dayjs(value, ['DD/MM/YYYY', 'D/M/YYYY', dayjs.ISO_8601], true)
      return d.isValid() ? d : null
    },
    formatCreatedDate (value) {
      const d = this.parseDate(value)
      if (!d) {
        return String(value || '')
      }
      return d.format('ddd, DD MMM YYYY').toUpperCase()
    },
    normalizeItem (itm, idx) {
      const estimateNumber = itm.estimateNumber || itm.estimate_number || ''
      const regoNumber = itm.regoNumber || itm.rego_number || ''
      const customerName = itm.customerName || itm.customer_name || ''
      const insurerName = itm.insurerName || itm.insurer_name || ''
      const make = itm.make || ''
      const model = itm.model || ''
      const buildDate = itm.buildDate || itm.dom || ''
      const createdDate = itm.createdDate || itm.created_date || itm.date_created || ''
      const value = itm.value || itm.estimate_id || itm.id || null
      const label = itm.label || `${estimateNumber}${regoNumber ? ' - ' + regoNumber : ''} ${customerName}`.trim()
      const card_id = itm.card_id || null
      const pinImageId = itm.pinImageId || null
      return {
        key: `${value || 'item'}-${idx}`,
        value,
        label,
        estimateNumber,
        regoNumber,
        customerName,
        insurerName,
        make,
        model,
        buildDate,
        createdDate,
        pinImageId,
        card_id,
      }
    },
    onSelect (itm) {
      if (itm && itm.value !== null && itm.value !== undefined) {
        this.$router.push('/estimates/view/' + itm.value)
      }
      this.$emit('select', itm)
    },
  },
}
</script>

<style scoped>
.related-est{
 max-width: 600px;
 float: right;
}
.related-est__list {
  position: static;
  width: 100%;
  max-height: 420px;
}

.related-est__thumb {
  margin-right: 10px;
  background-color: rgba(28, 31, 57, 0.06);
  border-radius: 4px;
}
.related-est__thumb img{
  object-fit: cover;
  width: 60px;
}

.related-est__customer {
  font-weight: 700;
  text-transform: uppercase;
}

.related-est__vehicle {
  font-weight: 800;
}

.related-est__insurer {
  font-size: 12px;
  color: #7e7e7e;
  font-weight: 800;
}

.related-est__empty {
  padding: 16px;
  color: #7e7e7e;
  font-weight: 600;
}

.additional-menu-search-filter {
  cursor: pointer;
}

.tabs-nav-right-search-dropdown-item:hover {
  background-color: rgba(94, 121, 255, 0.1);

}

.additional-menu-search-filter .tabs-nav-right-search-dropdown-item:focus {
  background-color: rgb(243, 243, 243);
}

.custom-dropdown {
  border: 1px solid #fff;
  padding-top: 7px;
  padding-bottom: 7px;
  box-shadow: 0 2px 20px 0 rgb(0 0 0 / 10%);
  border-radius: 3px;
  text-align: left;
  list-style: none;
  min-width: 12rem;
  background: #fff;
  overflow: auto;
}

.custom-dropdown.additional-menu-search-filter {
  width: 100%;
}

.custom-dropdown .tabs-nav-right-search-dropdown-item {
  border: 3px solid #bebebe;
  padding: 5px 10px;
  display: inline-block;
  width: 100%;
  margin-bottom: 5px;
  border-radius: 4px;

}

.custom-dropdown .tabs-nav-right-search-dropdown-item.active {
  border: 3px solid #5e77fc;
}

.custom-dropdown .tabs-nav-right-search-dropdown-item-header {
  color: rgb(28, 31, 57);
  font-weight: 600;
  margin-bottom: 3px;
  font-size: 13px;
}

.custom-dropdown .tabs-nav-right-search-dropdown-item-header.active {
  color: #5e77fc;
}

.custom-dropdown .tabs-nav-right-search-dropdown-item-header .tabs-nav-right-search-dropdown-item-header-weight {
  font-weight: 900;
}

.custom-dropdown .tabs-nav-right-search-dropdown-item-footer {
  font-weight: 600;
  color: rgb(28, 31, 57);
  font-size: 12px;
  display: flex;
  gap: 10px;
}

.related-est__created-date {
  display: flex;
  justify-content: space-between;
}
</style>
